import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, LogOut, User, Bookmark } from 'lucide-react';
import NotificationBell from './NotificationBell';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { AuthContext } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();

  return (
    <nav className="bg-gradient-to-r from-blue-600 to-blue-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2 font-bold text-xl">
            <Logo size={72} />
            <span>Talent Link</span>
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="hover:text-blue-200 transition">Home</Link>
            <Link to="/about" className="hover:text-blue-200 transition">About</Link>
            <Link to="/jobs" className="hover:text-blue-200 transition">Vacancies</Link>
            <Link to="/education" className="hover:text-blue-200 transition">Learn</Link>
            <Link to="/saved" className="hover:text-blue-200 transition flex items-center gap-1"><Bookmark size={16}/>Saved Vacancies</Link>
            <NotificationBell />
            
            {user ? (
              <>
                <Link to="/dashboard" className="hover:text-blue-200 transition flex items-center space-x-1">
                  <User size={20} />
                  <span>Dashboard</span>
                </Link>
                <Link to="/profile" className="hover:text-blue-200 transition">Profile</Link>
                {user.user_type === 'employer' && (
                  <Link to="/post-job" className="bg-green-500 px-4 py-2 rounded hover:bg-green-600 transition">
                    Post Job
                  </Link>
                )}
                <button onClick={() => { logout(); navigate('/'); }} className="bg-red-500 px-4 py-2 rounded hover:bg-red-600 transition flex items-center space-x-1">
                  <LogOut size={20} />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="hover:text-blue-200 transition">Login</Link>
                <Link to="/register" className="bg-green-500 px-4 py-2 rounded hover:bg-green-600 transition">Register</Link>
                <Link to="/profile" className="hover:text-blue-200 transition">Profile</Link>
              </>
            )}
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <Link to="/" className="block hover:bg-blue-700 p-2 rounded">Home</Link>
            <Link to="/about" className="block hover:bg-blue-700 p-2 rounded">About</Link>
            <Link to="/jobs" className="block hover:bg-blue-700 p-2 rounded">Vacancies</Link>
            <Link to="/education" className="block hover:bg-blue-700 p-2 rounded">Learn</Link>
            <Link to="/saved" className="block hover:bg-blue-700 p-2 rounded">Saved Vacancies</Link>
            {user ? (
              <>
                <Link to="/dashboard" className="block hover:bg-blue-700 p-2 rounded">Dashboard</Link>
                {user.user_type === 'employer' && (
                  <Link to="/post-job" className="block hover:bg-blue-700 p-2 rounded">Post Job</Link>
                )}
                <button onClick={() => { logout(); navigate('/'); }} className="w-full text-left hover:bg-red-600 p-2 rounded">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="block hover:bg-blue-700 p-2 rounded">Login</Link>
                <Link to="/register" className="block hover:bg-blue-700 p-2 rounded">Register</Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
